import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import SectionHeader from "../components/SectionHeader";
import VideoPlayer from "../components/VideoPlayer";

const CAT_ORDER = ["Full Movie Song", "Sohar Geet", "Swagat Geet", "Trailer", "Song"];
const CAT_LABELS = {
  "Full Movie Song": { hi: "फुल मूवी सॉन्ग", en: "Full Movie Song" },
  "Sohar Geet": { hi: "सोहर गीत", en: "Sohar Geet" },
  "Swagat Geet": { hi: "स्वागत गीत", en: "Swagat Geet" },
  "Trailer": { hi: "ट्रेलर", en: "Trailer" },
  "Song": { hi: "गीत", en: "Song" },
};

export default function MusicPage() {
  const [songs, setSongs] = useState([]);
  useEffect(() => {
    document.title = "Music & Videos — Je Ke Pictures";
    api.get("/songs").then(r => setSongs(r.data)).catch(() => {});
  }, []);

  const groups = songs.reduce((acc, s) => {
    const c = s.category || "Song";
    (acc[c] = acc[c] || []).push(s);
    return acc;
  }, {});
  const categories = Object.keys(groups).sort((a, b) => {
    const ia = CAT_ORDER.indexOf(a), ib = CAT_ORDER.indexOf(b);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib) || a.localeCompare(b);
  });

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="music-page">
      <SectionHeader eyebrow="Music & Videos" title="Songs & Soundscapes" subtitle="Video releases from our films, organised by category." />

      {categories.length === 0 && (
        <div className="text-[color:var(--jk-muted)]" data-testid="music-empty">No videos published yet. Check back soon.</div>
      )}

      <div className="space-y-20">
        {categories.map((cat) => {
          const label = CAT_LABELS[cat] || { hi: "", en: cat };
          return (
            <section key={cat} data-testid={`video-category-${cat.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="flex items-baseline gap-4 mb-8 border-b border-white/10 pb-4">
                {label.hi && <h2 className="font-hindi text-3xl md:text-4xl text-[color:var(--jk-gold)]">{label.hi}</h2>}
                <span className="font-cinzel text-xs tracking-[0.35em] uppercase text-[color:var(--jk-muted)]">{label.en}</span>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                {groups[cat].map((s) => (
                  <div key={s.id} data-testid={`song-item-${s.id}`}>
                    <VideoPlayer src={s.video_url} poster={s.poster_url} youtubeId={s.youtube_id} title={s.title} />
                    <div className="mt-5 border-l-2 border-[color:var(--jk-gold)] pl-4">
                      {s.title_hindi && <div className="font-hindi text-2xl mb-1">{s.title_hindi}</div>}
                      <h3 className="font-cinzel font-bold text-xl mb-1">{s.title}</h3>
                      {s.film_title && <div className="text-xs font-cinzel tracking-widest text-[color:var(--jk-muted)] uppercase mb-3">From {s.film_title}</div>}
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
                        {s.singer && <div><span className="block text-[0.65rem] tracking-widest text-[color:var(--jk-gold)] font-cinzel uppercase">Singer</span>{s.singer}</div>}
                        {s.lyricist && <div><span className="block text-[0.65rem] tracking-widest text-[color:var(--jk-gold)] font-cinzel uppercase">Lyricist</span>{s.lyricist}</div>}
                        {s.composer && <div><span className="block text-[0.65rem] tracking-widest text-[color:var(--jk-gold)] font-cinzel uppercase">Composer</span>{s.composer}</div>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
